import { CSSObject } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const previewWrapper = (isTooltipActive: boolean): CSSObject => ({
  position: 'relative',
  overflow: 'hidden',
  '.kuiper-preview-wrapper:hover .kuiper-settings-icon-wrapper': {
    opacity: '95%',
    height: '33px',
    transitionDelay: '0.1s',
  },
  '.kuiper-settings-icon-wrapper': {
    opacity: isTooltipActive ? '95%' : 0,
    height: isTooltipActive ? '33px' : 0,
    transitionDelay: '0.1s',
  },
})

export const settingsIconWrapper = (readOnly: boolean = false): CSSObject => ({
  padding: '5px',
  backgroundColor: colors.n3.base,
  position: 'absolute',
  opacity: '0',
  height: '0',
  bottom: '0',
  // Offset 1px on both sides to fit inside parent border
  left: '1px',
  right: '1px',
  transition: 'height 0.1s ease-out, opacity 0.1s ease-out',
  display: 'flex',
  flexDirection: readOnly ? 'row' : 'row-reverse',
  justifyContent: 'space-between',
})

export const settingsIcon = (isTooltipActive: boolean): CSSObject => ({
  height: '30px',
  width: '32px',
  paddingTop: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  backgroundColor: isTooltipActive ? colors.n3.base : 'none',
})

export const arrowsWrapper: CSSObject = {
  padding: 0,
  margin: 0,
  listStyleType: 'none',
  display: 'flex',

  li: {
    marginRight: '2px',
    borderRadius: '4px',
    backgroundColor: colors.n4.base,

    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '10px',
      background: 'none',
      border: 0,
      cursor: 'pointer',

      '&:disabled': {
        cursor: 'default',
      },
    },

    '.lapidary-icon': {
      color: colors.n3.base,
    },
    '&:hover button:not(:disabled) .lapidary-icon': {
      color: 'white',
    },
  },
}

export const baseStyle = ({
  color = '',
  fontSize = '',
  useInline,
}: {
  color?: string
  fontSize?: string
  useInline: boolean
}): CSSObject => ({
  backgroundColor: 'white',
  color: color || '#000',
  fontFamily: fonts.sansSerif,
  fontSize: fontSize || 14,
  display: 'flex',
  flexDirection: useInline ? 'row' : 'column',
})

export const assetStyle: CSSObject = {
  display: 'flex',
  overflow: 'hidden',
  minWidth: '100px',
}

export const linkStyle = (hasFooter: boolean): CSSObject => ({
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderBottom: hasFooter ? 'unset' : '',
  borderBottomLeftRadius: hasFooter ? 'unset' : '',
  borderBottomRightRadius: hasFooter ? 'unset' : '',
})

export const inlineIcon = (hasIcon: boolean): CSSObject => ({
  display: hasIcon ? 'flex' : 'block',
})

export const fieldIcon: CSSObject = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: '7px',
}

export const footerBarStyle: CSSObject = {
  borderTop: 'unset',
  borderTopLeftRadius: 'unset',
  borderTopRightRadius: 'unset',
  padding: 'unset',
  width: 'unset',
}

export const footerSettingsIconWrapper = (
  isTooltipActive: boolean
): CSSObject => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  opacity: isTooltipActive ? 1 : 0,
  transition: 'opacity 0.2s ease-in',
  '&:hover': {
    opacity: 1,
  },
})
